module.exports = __webpack_public_path__ + "assets/img/title.297ae9b9.png";